import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import { Dialog, CircularProgress } from '@mui/material';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`;

const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    padding: '0',
    maxWidth: '320px',
    width: '100%',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
  },
});

const LoaderContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '48px 32px',
  animation: `${fadeIn} 0.3s ease-out`,
});

const LoaderText = styled('div')({
  marginTop: '20px',
  fontSize: '16px',
  fontWeight: 500,
  color: '#333',
  textAlign: 'center',
  animation: `${pulse} 2s ease-in-out infinite`,
});

const SubText = styled('div')({
  marginTop: '8px',
  fontSize: '13px',
  color: '#888',
  textAlign: 'center',
});

function FormSubmitLoader({ open }) {
  return (
    <StyledDialog open={open} maxWidth="xs">
      <LoaderContent>
        <CircularProgress size={48} thickness={4} sx={{ color: '#333' }} />
        <LoaderText>Submitting...</LoaderText>
        <SubText>Please wait</SubText>
      </LoaderContent>
    </StyledDialog>
  );
}

export default FormSubmitLoader;
